function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { BIRMINGHAM_MIDSHIRES, BOS, HALIFAX, LLOYDS, MBNA, SCOTTISH_WIDOWS, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT } from "../../constants";
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm-1.8 17.4l-4.68-4.68 2.28-2.4 2.4 2.4 6-6.24 2.4 2.4-8.4 8.52z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 Z M12,2.83333333 C17.0626102,2.83333333 21.1666667,6.93738979 21.1666667,12 C21.1666667,17.0626102 17.0626102,21.1666667 12,21.1666667 C6.93738979,21.1666667 2.83333333,17.0626102 2.83333333,12 C2.83333333,6.93738979 6.93738979,2.83333333 12,2.83333333 Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    fillRule: "nonzero",
    points: "17 7 18.4358008 8.39229167 8.99062767 18.1326265 5 14.0172917 6.43580079 12.625 8.98990039 15.2591458"
  })));
};
HalifaxIcon.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm4.694-17l-6.083 6.132-2.305-2.355L6 13.132l4.66 4.71L19 9.355 16.694 7z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
LloydsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var MaterialIcon = function MaterialIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.2073 17.3733L18.6996 8.88097L17.3684 7.54982L10.2073 14.711L6.60728 11.111L5.27613 12.4421L10.2073 17.3733ZM12.0021 24C10.3424 24 8.78236 23.6851 7.32198 23.0552C5.86157 22.4253 4.59123 21.5704 3.51096 20.4906C2.43066 19.4108 1.57543 18.141 0.945255 16.6813C0.315085 15.2215 0 13.6618 0 12.0021C0 10.3424 0.314948 8.78236 0.944845 7.32198C1.57474 5.86157 2.42959 4.59123 3.50938 3.51096C4.58919 2.43066 5.85897 1.57543 7.31872 0.945255C8.77845 0.315085 10.3382 0 11.9979 0C13.6576 0 15.2176 0.314948 16.678 0.944844C18.1384 1.57474 19.4088 2.42959 20.489 3.50938C21.5693 4.58919 22.4246 5.85897 23.0547 7.31872C23.6849 8.77845 24 10.3382 24 11.9979C24 13.6576 23.6851 15.2176 23.0552 16.678C22.4253 18.1384 21.5704 19.4088 20.4906 20.489C19.4108 21.5693 18.141 22.4246 16.6813 23.0547C15.2215 23.6849 13.6618 24 12.0021 24ZM12 22.1053C14.8211 22.1053 17.2105 21.1263 19.1684 19.1684C21.1263 17.2105 22.1053 14.8211 22.1053 12C22.1053 9.17894 21.1263 6.78946 19.1684 4.83156C17.2105 2.87366 14.8211 1.89471 12 1.89471C9.17894 1.89471 6.78946 2.87366 4.83156 4.83156C2.87366 6.78946 1.89471 9.17894 1.89471 12C1.89471 14.8211 2.87366 17.2105 4.83156 19.1684C6.78946 21.1263 9.17894 22.1053 12 22.1053Z",
    fill: "currentColor"
  }));
};
MaterialIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM19.625 8.175L10.111 17.686C9.83 17.966 9.375 17.966 9.093 17.686L4.375 12.967C3.825 12.417 3.88 11.491 4.539 11.016C5.056 10.643 5.783 10.753 6.234 11.204L9.096 14.066C9.376 14.346 9.83 14.346 10.11 14.066L17.765 6.412C18.216 5.961 18.943 5.852 19.459 6.224C20.119 6.699 20.175 7.625 19.625 8.175Z",
    fill: "currentColor"
  }));
};
MbnaIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.37232 0 0 5.37273 0 11.9997C0 18.6273 5.37232 24 12 24C18.6277 24 24 18.6273 24 12.0003C24 5.37273 18.6277 0 12 0ZM6.29289 11.6364C6.68342 11.2459 7.31658 11.2459 7.70711 11.6364L10.3895 14.3188L17.0262 7.68205C17.4167 7.29153 18.0499 7.29153 18.4404 7.68205C18.8309 8.07258 18.8309 8.70574 18.4404 9.09627L10.3895 17.1472L6.29289 13.0506C5.90237 12.6601 5.90237 12.0269 6.29289 11.6364Z",
    fill: "currentColor"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useTheme } from 'styled-components';
export default function (_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme() || {};
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.positive) {
    var _theme$assets2, _theme$assets2$icons;
    svg = (_theme$assets2 = theme.assets) === null || _theme$assets2 === void 0 ? void 0 : (_theme$assets2$icons = _theme$assets2.icons) === null || _theme$assets2$icons === void 0 ? void 0 : _theme$assets2$icons.positive;
  } else {
    switch (brand) {
      case BOS:
        svg = BosIcon;
        break;
      case BIRMINGHAM_MIDSHIRES:
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsIcon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = MaterialIcon;
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn("Icon is not available in brand \"".concat(brand, "\"."));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}